export default {
  getList: {
    method: 'post',
    url: '/ws-admincp/node/connection/list?nodeId='
  },
  add: {
    method: 'post',
    url: '/ws-admincp/node/connection'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/node/connection'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/node/connection/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/node/connection/restore'
  },
  getById: {
    method: 'get',
    url: '/ws-admincp/node/connection/ID'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/node/connection/ID'
  }
}
